module.exports = __webpack_public_path__ + "img/Professional Gaming.49bb9923.png";